import { createFileRoute } from '@tanstack/react-router';

import { MissionDetailPage } from '@/features/midoffice/operations/MissionDetailPage';

export const Route = createFileRoute('/midoffice/$missionId')({
	component: MissionDetailRoute,
});

function MissionDetailRoute() {
	const { missionId } = Route.useParams();
	return <MissionDetailPage missionId={missionId} />;
}
